import React, { useEffect, useState } from "react";
import SipDetails from "./Sip";
import Lumpsum from "./Lumpsum";
import LumpsumSip from "./LumpsumSip";
import {
  getNewPurchaseFundList,
  storeSchemeDetails,
} from "../../../../store/actions";
import {
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@material-ui/core";
import { connect } from "react-redux";

const SchemeDetails = (props) => {
  const schemes = ["Lumpsum", "SIP", "Lumpsum + SIP"];
  const [scheme, setScheme] = useState("Lumpsum");
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <div className="container-margin" style={{ marginBottom: "10px" }}>
        <span
          style={{ fontWeight: 900, marginTop: "12px",display:"flex"}}
          className="input-margin"
        >
          Mode of Transaction *
        </span>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="Search"
            name="search"
            value={scheme}
            style={{ flexDirection: "row" }}
            onChange={(e) => setScheme(e.target.value)}
          >
            {schemes.map((mode) => (
              <div
                className={`investor-radio-button input-margin-investor-flow dual-margin-investor-flow ${
                  scheme === mode ? "investor-active" : ""
                }`}
              >
                <FormControlLabel
                  value={mode}
                  control={
                    <Radio
                      className="investor-search-radio"
                      style={{ color: "#003d7b" }}
                    />
                  }
                  className="investor-formcontrol-label"
                  style={{ margin: 0 }}
                />
                <div className="investor-form-label">
                  {mode === "SIP" ? "SIP(Without Payment)" : mode}
                </div>
              </div>
            ))}
          </RadioGroup>
        </FormControl>
      </div>
      {scheme === "Lumpsum" ? <Lumpsum /> : ""}
      {scheme === "SIP" ? <SipDetails /> : ""}
      {scheme === "Lumpsum + SIP" ? <LumpsumSip /> : ""}
    </>
  );
};
export default connect(null, { getNewPurchaseFundList, storeSchemeDetails })(
  SchemeDetails
);
